/* unplugin-vue-components disabled */import script from "./user.vue?vue&type=script&setup=true&lang=ts"
export * from "./user.vue?vue&type=script&setup=true&lang=ts"

import "./user.vue?vue&type=style&index=0&id=40484c44&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40484c44"]])

export default __exports__